import { create } from "zustand";

type PeriodeState = {
  activePeriod: string; // e.g. "2026-2"
  periodeId: number | null;
  setActivePeriod: (period: string, periodeId?: number | null) => void;
  getYearAndSemester: () => {
    year: number;
    semester: number;
    periodeId: number | null;
  };
};

export const usePeriodeStore = create<PeriodeState>((set, get) => ({
  activePeriod: "", // Akan di-set otomatis dari periode terbaru API
  periodeId: null,
  setActivePeriod: (period, periodeId = null) =>
    set({ activePeriod: period, periodeId }),
  getYearAndSemester: () => {
    const [year, semester] = get().activePeriod.split("-");
    return {
      year: parseInt(year) || 2025,
      semester: parseInt(semester) || 2,
      periodeId: get().periodeId,
    };
  },
}));
